import { EditableAvatar } from '@components/editable-avatar';
import { useBoolean, useDefaultImage } from '@lib/common';
import { useMemo, useState } from 'react';
import { createFormField, useCompanyFormState } from '../common';
import { windowObj } from '@lib/common';

const defaultImage = '/images/company_default.svg';

export const FallbackLogo = ({ value, onChange }) => {
  const { company, edit } = useCompanyFormState();
  const srcList = useMemo(() => {
    if (edit) {
      return [
        `${windowObj.RAZZLE_S3_BUCKET_URL}/${company.vtr_id}.png`,
        company.logo_url ? `${windowObj.RAZZLE_TMDB_IMAGE_URL}${company.logo_url}` : '',
        '/images/company_default.svg',
      ].filter(e => e);
    }
    return ['/images/company_default.svg'];
  }, [company, edit]);

  const { src: fallbackedSource } = useDefaultImage({
    srcList,
    defaultSrc: '/images/company_default.svg',
    useSuspense: false,
  });

  const [isDeleted, setIsDeleted] = useState(false);

  const source = isDeleted ? null : (value && value.trim()) || fallbackedSource;
  const isDefaultImage = defaultImage === source;

  const onEditorChange = (value: string) => {
    if (!value) {
      // delte the image
      setIsDeleted(true);
      onChange && onChange('deleted');
    } else {
      setIsDeleted(false);
      onChange && onChange(value);
    }
  };

  const hideActions = isDeleted || isDefaultImage;

  return (
    <EditableAvatar
      hideDelete={hideActions}
      hideEdit={hideActions}
      hideDownload={hideActions}
      value={source}
      onChange={onEditorChange}
      empty="No Logo"
    />
  );
};

export const CompanyLogoField = createFormField(FallbackLogo);
